import theme from '@/theme';
import styled from '@emotion/styled';

const StyledTableRow = styled.tr<{ height?: string; onClick?: any }>`
    display: flex;
    padding: 12px 20px;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
    height: ${({ height }) => height || '64px'};

    :hover {
        background-color: ${({ onClick }) => (onClick ? theme.colors.black[50] : 'transparent')};
    }

    td {
        color: ${theme.colors.secondary.main};
        font-size: 14px;
        font-weight: 400;
    }
`;

interface Props {
    children: React.ReactNode;
    onClick?: () => void;
    height?: string;
}

export const TableRow = ({ children, onClick, height = 'px' }: Props) => {
    return (
        <StyledTableRow onClick={onClick} height={height}>
            {children}
        </StyledTableRow>
    );
};
